<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="title" />
          <!-- /Page Header -->

          <!-- Settings Menu -->
          <settings-tabs></settings-tabs>
          <!-- /Settings Menu -->

          <div class="row">
            <div class="col-xl-12 col-lg-12">
              <!-- Prefixes -->
              <div class="card">
                <div class="card-body">
                  <div class="settings-header">
                    <!-- <website-sidebar></website-sidebar> -->
                    <website-sidebar :file_id="file_id" :show_assign_data="show_assign_data"></website-sidebar>
                  </div>
                  <form @submit.prevent="createMode" v-if="createModules.length > 0">
                    <div class="row align-items-center py-4">
                      <div class="col"></div>
                      <div class="col-md-7">

                        <div class="col-md-12" v-if="shouldShowUniqueIdentify">
                          <div class="row">
                            <div class="col-12">
                              <h6 class="bg-teal text-capitalize px-2 py-3">{{ "Organisation" }}</h6>
                            </div>
                          </div>
                          <div class="storage-wrap prefer-wrap d-block">
                            <div class="row align-items-center">

                              <div class="col-md-4">
                                <p>Uniquely identify by</p>
                              </div>
                              <div class="col-md-8">
                                <select class="form-select" v-model="selectedValue" @change="orgChange">
                                  <option v-for="val in identifyBy" :key="val.id" :value="val.id">
                                    {{ val.value }}
                                  </option>
                                </select>
                              </div>
                            </div>

                          </div>
                        </div>

                        <div class="row mb-3" v-for="mode in createModules" :key="mode.id">
                          <div class="col-md-12">
                            <div class="row">
                              <div class="col-12">
                                <h6 class="bg-teal text-capitalize px-2 py-3">{{ mode.name }}</h6>
                              </div>
                            </div>
                            <div class="storage-wrap prefer-wrap d-block">
                              <div class="row align-items-center">
                                <div class="col-md-4">
                                  <p v-if="!isImportMode(mode) && shouldShowLabel(mode)">
                                    Uniquely identify by</p>
                                </div>
                                <div class="col-md-8">
                                  <select v-if="mode.name === 'organisations'" class="form-select"
                                    v-model="formData.create_mode_data[mode.id].uniquely_identify_by">
                                    <!-- <option value="">-----Select-----</option> -->
                                    <option v-for="val in identifyBy" :key="val.id" :value="val.id">
                                      {{ val.value }}
                                    </option>
                                  </select>
                                  <select
                                    v-if="(mode.name === 'opportunities' && !isImportMode(mode)) && (mode.name === 'opportunities' && formData.create_mode_data[mode.id].import_mode !== 'create_new')"
                                    class="form-select"
                                    v-model="formData.create_mode_data[mode.id].uniquely_identify_by">
                                    <!-- <option value="">-----Select-----</option> -->
                                    <option v-for="val in identifyOppBy" :key="val.id" :value="val.id">
                                      {{ val.value }}
                                    </option>
                                  </select>

                                  <select v-if="mode.name === 'person'" class="form-select"
                                    v-model="formData.create_mode_data[mode.id].uniquely_identify_by">
                                    <!-- <option value="">-----Select-----</option> -->
                                    <option v-for="val in identifyPerBy" :key="val.id" :value="val.id">
                                      {{ val.value }}
                                    </option>
                                  </select>

                                  <select
                                    v-if="mode.name === 'contracts' && formData.create_mode_data[mode.id].import_mode !== 'create_new'"
                                    class="form-select"
                                    v-model="formData.create_mode_data[mode.id].uniquely_identify_by">
                                    <!-- <option value="">-----Select-----</option> -->
                                    <option v-for="val in identifyContBy" :key="val.id" :value="val.id">
                                      {{ val.value }}
                                    </option>
                                  </select>

                                </div>
                              </div>
                              <div class="row align-items-center my-3">
                                <div class="col-md-4" v-if="shouldShowImport(mode)">
                                  <p>Import mode </p>
                                </div>
                                <div class="col-md-8">
                                  <!-- <p class="form-control">Update existing, create new </p> -->

                                  <select v-if="mode.name === 'organisations' && shouldShowImport(mode)" class="form-select bg-gray"
                                    v-model="formData.create_mode_data[mode.id].import_mode" disabled>
                                    <!-- <option value="">-----Select-----</option> -->
                                    <option v-for="val in importMode" :key="val.id" :value="val.id">
                                      {{ val.value }}
                                    </option>
                                  </select>
                                  <select v-if="mode.name === 'opportunities' && shouldShowImport(mode)" class="form-select" 
                                  :class="{ 'bg-gray': isImportMode(mode) }" v-model="formData.create_mode_data[mode.id].import_mode"
                                    :disabled="isImportMode(mode)" @change="isOrganisation(mode)">
                                    <!-- <option value="">-----Select-----</option> -->
                                    <option v-for="val in importMode" :key="val.id" :value="val.id">
                                      {{ val.value }}
                                    </option>
                                  </select>

                                  <select v-if="mode.name === 'person' && shouldShowImport(mode)" class="form-select bg-gray"
                                    v-model="formData.create_mode_data[mode.id].import_mode" disabled>
                                    <!-- <option value="">-----Select-----</option> -->
                                    <option v-for="val in importMode" :key="val.id" :value="val.id">
                                      {{ val.value }}
                                    </option>
                                  </select>

                                  <select v-if="mode.name === 'contracts' && shouldShowImport(mode)" class="form-select"
                                    v-model="formData.create_mode_data[mode.id].import_mode"
                                    @change="isOrganisation(mode)">
                                    <!-- <option value="">-----Select-----</option> -->
                                    <option v-for="val in importMode" :key="val.id" :value="val.id">
                                      {{ val.value }}
                                    </option>
                                  </select>

                                </div>
                              </div>
                              <!-- <div class="setting-gateway justify-content-center">
                                <div class="form-wrap d-flex mb-0">
                                  <div class="status-toggle">
                                    <input type="checkbox" :id="'checkbox-' + mode.id" class="check"
                                      v-model="formData.create_mode_data[mode.id].ignore_blank_fields" :true-value="1"
                                      :false-value="0" />
                                    <label :for="'checkbox-' + mode.id" class="checktoggle"></label>
                                  </div>
                                  <div class="storage-icon ms-2">
                                    <h6>Ignore blank data fields</h6>
                                  </div>
                                </div>
                              </div> -->

                              <!-- <div class="row align-items-center my-3" v-if="mode.name === 'person'">
                                <div class="col-md-4">
                                  <p>Import name </p>
                                </div>
                                <div class="col-md-8">
                                  <select class="form-select" v-model="selectedPerImportName">
                                    <option v-for="val in importName" :key="val.id" :value="val.id">
                                      {{ val.value }}
                                    </option>
                                  </select>
                                </div>
                              </div> -->

                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col"></div>
                    </div>
                    <div class="submit-button text-end">
                      <button type="submit" class="btn btn-primary">Save</button>
                      <!-- <router-link class="btn btn-teal" :to="{ path: '/data-import/map-data', query: {useMapping: mapping_id, fileId: file_id } }">
                        Save & Ready to map</router-link> -->
                    </div>
                  </form>
                  <div class="row" v-else>
                    <div class="col"></div>
                    <div class="col-md-7 py-3 bg-light">
                      <p class="text-center "><i class="ion-information-circled"></i> Please upload and validate a file
                      </p>
                    </div>
                    <div class="col"></div>
                  </div>
                </div>
              </div>
              <!-- /Prefixes -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { message } from 'ant-design-vue';
import { reactive } from 'vue';

export default {
  data() {
    return {
      title: "Settings",
      selectedName: 1,
      selectedOppValue: 1,
      selectedPerValue: 1,
      selectedContValue: 1,
      selectedPerImportName: 1
    };
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const selectedValue = ref('organization_name_postcode');
    const importName = ref([
      { id: 1, value: 'Full Name' },
      { id: 2, value: 'Separate first and last name' }
    ]);
    const importMode = ref([
      { id: 'update_existing_create_new', value: 'Update existing, create new' },
      { id: 'create_new', value: 'Always create new' }
    ]);
    const identifyBy = ref([
      { id: 'organization_name_postcode', value: 'Organisation name + Postcode' },
      { id: 'organization_number', value: 'Organisation number' },
      // { id: 3, value: 'ERP ID' },
      // { id: 4, value: 'Organisation name + Postcode + Territory' },
      // { id: 5, value: 'ERP ID + Territory' }
    ]);
    const identifyOppBy = ref([
      // { id: 1, value: 'Meter Opportunity System ID' },
      // { id: 2, value: 'Organisation + Meter Opportunity number' },
      { id: 'opportunity_number', value: 'Meter Opportunity number' }
    ]);

    const identifyPerBy = ref([
      { id: 'person_number', value: 'Person number' },
      { id: 'org_name_postcode_person_email', value: 'Org name + Org postcode + Person email' },
      { id: 'org_name_postcode_person_name', value: 'Org name + Org postcode + Person First name + Person Last Name' },
    ]);

    const identifyContBy = ref([
      // { id: 1, value: 'Contract System ID' },
      // { id: 2, value: 'Organisation + Contract number' },
      { id: 'contract_number', value: 'Contract number' },
    ]);

    const importValue = ref({
      selectedOrgImportValue: 'update_existing_create_new',
      selectedPerImportValue: 'update_existing_create_new',
      selectedOppImportValue: 'update_existing_create_new',
      selectedContImportValue: 'update_existing_create_new',
    })


    // Computed property to determine whether the label should be shown
    const shouldShowLabel = (mode) => {
      return (
        mode?.name === "organisations" ||
        (mode?.name === "opportunities" && formData.value?.create_mode_data?.[mode?.id]?.import_mode !== 'create_new') ||
        mode?.name === "person" ||
        (mode?.name === "contracts" && formData.value?.create_mode_data?.[mode?.id]?.import_mode !== 'create_new')
      );
    };

    const shouldShowImport = (mode) => {
      return (
        (mode?.name === "organisations" && formData.value?.create_mode_data?.[mode?.id]?.import_mode) ||
        (mode?.name === "opportunities" && formData.value?.create_mode_data?.[mode?.id]?.import_mode ) ||
        (mode?.name === "person" && formData.value?.create_mode_data?.[mode?.id]?.import_mode ) ||
        (mode?.name === "contracts" && formData.value?.create_mode_data?.[mode?.id]?.import_mode )
      );
    };

    const shouldShowUniqueIdentify = ref(false);

    const isOrganisation = (mode) => {
      const orgModule = allModules.value.find((module) => module.name === "organisations");

      // if (!orgModule) return; // Prevent errors if no organisations module exists

      const shouldIdentify = !createModules.value.some((module) => module.name === "organisations");

      const import_mode = formData.value.create_mode_data?.[mode?.id]?.import_mode;

      if (shouldIdentify && import_mode === "create_new") {
        shouldShowUniqueIdentify.value  = true;
        // ✅ Preserve previous existing data while adding new properties
        formData.value.create_mode_data[orgModule.id] = {
          ...formData.value.create_mode_data[orgModule.id], // Preserve existing data
          module_id:orgModule.id,
          // name: "organisation",
          ignore_blank_fields:0,
          import_mode:'',
          uniquely_identify_by: selectedValue.value,
        };
      } else if(shouldIdentify && import_mode === "update_existing_create_new"){
        // Optionally remove it if condition fails
        shouldShowUniqueIdentify.value  = false;
        delete formData.value.create_mode_data[orgModule.id];
      } 
      
      if((mode?.name === 'opportunities' || mode.name === 'contracts') &&  import_mode === "create_new") {
        formData.value.create_mode_data[mode.id].uniquely_identify_by = ''
      } 
      if(mode?.name === 'opportunities' &&  import_mode === "update_existing_create_new") {
        formData.value.create_mode_data[mode.id].uniquely_identify_by = 'opportunity_number'
      }
      if(mode.name === 'contracts' &&  import_mode === "update_existing_create_new") {
        formData.value.create_mode_data[mode.id].uniquely_identify_by = 'contract_number'
      }
    };


    // Computed Property for Conditional Rendering
    const isImportMode = (mode) => {

      const isValid = createModules.value.some((module) => module.name === "contracts");
      if ((isValid && mode.name === 'opportunities')) {
        return true;
      } else if((isValid && mode.name === 'contracts')){
        return false;
      } else {
        return false;
      }

    }

    const createModules = ref([]);
    const allModules = ref([]);
    const selectedModules = ref([])
    const file_id = ref(route.query.fileId || localStorage.getItem('fileId') || null);
    const mapping_id = ref(route.query.useMapping || null);
    const show_assign_data = ref(route.query.showAssignData || "true")

    const formData = ref({
      id: file_id,
      create_mode_data: {} // This will store the selected IDs
    });

    const fetchCreateData = async (id) => {
      try {
        const data = await store.dispatch("dataimport/fetchCreateMode", id);
        // createModules.value = data.file_modules;
        allModules.value = data.all_modules;

        createModules.value = data.file_modules.filter(module => selectedModules.value.includes(module.id));
        const shouldIdentify = createModules.value.some((module) => module.name === "organisations");
        shouldShowUniqueIdentify.value = data.file_modules.some(module => module.import_mode === "create_new") && !shouldIdentify;
        
        // Initialize `create_mode_data` with default values
        formData.value.create_mode_data = createModules.value.reduce((acc, module) => {

          acc[module.id] = {
            module_id: module.id,
            // ignore_blank_fields: module.ignore_blank_fields != null ? module.ignore_blank_fields : 0, // Set default value here
            ignore_blank_fields: 0,
            import_mode: module?.import_mode != null ? module?.import_mode : '',
            uniquely_identify_by: module?.uniquely_identify_by != null ? module?.uniquely_identify_by : '',
          };
          return acc;
        }, {});

      } catch (error) {
        console.error("Error fetching dataimport data:", error);
      }
    };

    const createMode = async () => {
      try {
        const response = await store.dispatch("dataimport/createMode", formData.value);

        if (response.status === 200) {
          // shouldShowUniqueIdentify.value  = false;
          fetchCreateData(formData.value.id)
          message.success(response.data.message);
      //     router.push({
      //   path: '/data-import/map-data',
      //   query: { useMapping: mapping_id.value, fileId: file_id.value },
      // });
        }
      } catch (error) {
        console.error("create mode failed:", error);
      }
    };

    const orgChange = async () => {
      const orgModule = allModules.value.find((module) => module.name === "organisations");
      formData.value.create_mode_data[orgModule.id].uniquely_identify_by = selectedValue.value;
     }

    onMounted(async () => {
      if (file_id.value) {
        const id = route.query.fileId || localStorage.getItem('fileId');
        const data = await store.dispatch("dataimport/fetchValidateData", id);
        selectedModules.value = data.selected_modules;
        fetchCreateData(file_id.value);
      }
    });

    return {
      formData,
      identifyBy,
      identifyOppBy,
      identifyPerBy,
      identifyContBy,
      importName,
      createMode,
      createModules,
      importMode,
      importValue,
      shouldShowLabel,
      shouldShowUniqueIdentify,
      isImportMode,
      isOrganisation,
      allModules,
      selectedValue,
      shouldShowImport,
      selectedModules,
      file_id,
      orgChange,
      // mapping_id
      show_assign_data
    };
  }
};
</script>
<style>
.bg-gray {
  background-color: rgba(236, 228, 228, 0.514) !important;
  cursor: not-allowed;
}
</style>
